import {isString} from 'ramda-adjunct';

import {UpdateWatermarkV2RequestBody, WatermarkPositionEnum} from '@dms/api/shared';

import {WatermarkFormType} from '../types/watermarkForm';

export const getRequestData = (data: WatermarkFormType): UpdateWatermarkV2RequestBody => ({
  name: data.name,
  size: data.size,
  position: data.position as WatermarkPositionEnum,
  fitToImage: data.fitToImage,
  usageType: data.usageType,
  fileId: (isString(data.fileId) ? data.fileId : data.fileId?.id) ?? null,
});
